export default "__VITE_ASSET__CzrHbOLs__"